/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublishGlobalProjectMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String'];
}>;


export type PublishGlobalProjectMutation = { __typename: 'Mutation', publishGlobalCampaign: { __typename: 'Campaign', id: string | null } | null };


export const PublishGlobalProjectDocument = gql`
    mutation publishGlobalProject($projectId: String!) {
  publishGlobalCampaign(id: $projectId) {
    id
  }
}
    `;
export type PublishGlobalProjectMutationFn = Apollo.MutationFunction<PublishGlobalProjectMutation, PublishGlobalProjectMutationVariables>;

/**
 * __usePublishGlobalProjectMutation__
 *
 * To run a mutation, you first call `usePublishGlobalProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishGlobalProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishGlobalProjectMutation, { data, loading, error }] = usePublishGlobalProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishGlobalProjectMutation(baseOptions?: Apollo.MutationHookOptions<PublishGlobalProjectMutation, PublishGlobalProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishGlobalProjectMutation, PublishGlobalProjectMutationVariables>(PublishGlobalProjectDocument, options);
      }
export type PublishGlobalProjectMutationHookResult = ReturnType<typeof usePublishGlobalProjectMutation>;
export type PublishGlobalProjectMutationOptions = Apollo.BaseMutationOptions<PublishGlobalProjectMutation, PublishGlobalProjectMutationVariables>;